import { countryFlag } from '@/lib/country-flag';
import { cn } from '@/lib/utils';
import type { ServerRegion } from '@/types/fleet';

export function RegionBadge({
  region,
  className,
}: {
  region: ServerRegion;
  className?: string;
}): JSX.Element {
  const flag = countryFlag(region.country);
  const place = [region.city, region.country].filter(Boolean).join(', ');

  return (
    <span className={cn('inline-flex items-center gap-1.5 font-mono text-xs', className)}>
      {flag && <span className="text-sm leading-none" aria-hidden>{flag}</span>}
      <span>{place || region.continent || '—'}</span>
    </span>
  );
}
